module.exports = __webpack_public_path__ + "img/no4.f5ec011c.jpg";